/**
 * Simple secure cookie utility for JWT tokens
 */

/**
 * Set JWT token as secure cookie with expiration
 * @param cookieName - cookie name
 * @param cookieContent - cookie content
 * @param hoursToExpire - Hours until cookie expires (default: 8)
 */
export const setSecureJWTCookie = (
    cookieName: string,
    cookieContent: string,
    hoursToExpire: number = 8
) => {
    const expirationTime = new Date();
    expirationTime.setHours(expirationTime.getHours() + hoursToExpire);

    document.cookie = `${cookieName}=${cookieContent}; path=/; secure; samesite=strict; expires=${expirationTime.toUTCString()}`;
};

export const getJWTcookieContent = (cookieContent: string) => {
    return 'Basic ' + btoa(encodeURIComponent(cookieContent));
};
